export enum EmptyStatesType {
  Empty = "Empty",
  Trades = "Trades",
  Signals = "Signals",
  Graph = "Graph",
  Marketplace = "Marketplace",
  Coins = "Coins",
  WideCoins = "WideCoins",
  PayoutMethods = "PayoutMethods",
  Connect = "Connect",
  FileSearch = "FileSearch",
  Search = "Search",
  Reviews = "Reviews",
  Bots = "Bots",
  BacktestingHistory = "BacktestingHistory",
  Configuration = "Configuration",
  ConfigurationSearch = "ConfigurationSearch",
  Users = "Users",
  Filters = "Filters",
  Gears = "Gears",
  Invoices = "Invoices",
}

export type EmptyStatesIcons = Record<
  EmptyStatesType,
  (props: any) => React.JSX.Element
>;
